import { useContext, useState } from 'react'
import { Grid, Divider } from '@mui/material';
import { ProviderSoldTicket } from '../TicketSold/TicketSoldForm';
import { RadioListItem } from 'components/Input/Radio';
import UploadFileItem from 'components/Input/UploadFile';
import { Extension } from 'utilities/utilities';
import { TextAreaItem } from 'components/Input/TextArea';

const ApproveCheckTicket = ({ isCommittee,isPermission = true }) => {

    const {
        form,
        isView,
        arrAttachmentList,
        setArrAttachmentList,
        onClearAttachFile
    } = useContext(ProviderSoldTicket);

    const [isRequireRemark, setIsRequireRemark] = useState(false)

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Divider textAlign="left" className="font-weight-500">ผลการตรวจสอบ</Divider>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <RadioListItem
                            id={"sApprove"}
                            name={"sApprove"}
                            required={true}
                            label='ผลการตรวจสอบ'
                            IsNotShowLabel
                            disabled={!isPermission}
                            row
                            onChange={(eValue) => {
                                setIsRequireRemark(eValue === "R")
                                if(eValue === "A")
                                {
                                    form.setValue("sRemark",null)

                                }
                                form.unregister("sRemark")
                                form.clearErrors("sRemark")
                            }}
                            options={[
                                { value: "A", label: "ผ่าน" },
                                { value: "R", label: "ไม่ผ่าน" },
                            ]}
                        />
                    </Grid>
                    {
                        isCommittee ?
                            <Grid item xs={12} >
                                <Grid container spacing={2}>
                                   {form.getValues("sApprove") === "A" && <Grid item xs={12}>
                                        <UploadFileItem
                                            id="upFile"
                                            name={"upFile"}
                                            key={"upFile"}
                                            arrFile={arrAttachmentList}
                                            setarrFile={setArrAttachmentList}
                                            IsFolder={false}
                                            IsMultiple={false}
                                            Extension={Extension.FileTicket}
                                            nLimitFile={30}
                                            sLimitFile={"MB"}
                                            onClearFile={onClearAttachFile}
                                            modeDisplay={"list"}
                                            sFolderTemp={"SoldTicket"}
                                            sPositionText={"right"}
                                            label='เอกสารแนบ'
                                            required={form.getValues("sApprove") === "A"}
                                            disabled={form.getValues("sApprove") !== "A" || !isPermission}
                                        />
                                        <br/>
                                    </Grid>}
                                   {form.getValues("sApprove") === "R" && <Grid item xs={12} md={8} style={{ marginTop: '6px' }}>
                                        <TextAreaItem
                                            id='sRemark'
                                            name='sRemark'
                                            required={isRequireRemark}
                                            label={"เหตุผล"}
                                            maxLength={250}
                                            fullWidth
                                            placeholder={"เหตุผล"}
                                            row={3}
                                            disabled={form.getValues("sApprove") !== "R" || !isPermission}
                                        />
                                    </Grid>}
                                </Grid>
                            </Grid>
                            :
                            <Grid item xs={12} md={10} style={{ marginTop: '0px' }}>
                                <TextAreaItem
                                    id='sRemark'
                                    name='sRemark'
                                    required={isRequireRemark}
                                    label={"เหตุผล"}
                                    maxLength={250}
                                    placeholder={"เหตุผล"}
                                    disabled={form.getValues("sApprove") !== "R" || isView}
                                    row={3}
                                />
                            </Grid>
                    }

                </Grid>
            </Grid>
        </Grid>
    )
}

export default ApproveCheckTicket